/**
 * Per-chassis VDSL line error-health rollup (HealthCounts.vdsl_errors,
 * from vdsl_inventory.error_health). Sits next to the rate-band pills on
 * Home and the location device list. Only shouts when ports are flagged —
 * a chassis with every line clean shows nothing extra.
 */
import { Badge } from "./Badge";

export type VdslErrorHealthCounts = {
  good: number;
  warning: number;
  critical: number;
  unknown: number;
  total: number;
};

export function VdslErrorCountsPills({
  counts,
}: {
  counts: VdslErrorHealthCounts | null | undefined;
}) {
  if (!counts || counts.warning + counts.critical === 0) return null;
  const tip =
    `VDSL line-error flags (last 7 days of ES / SES / UAS / FEC / retrains): ` +
    `${counts.critical} critical, ${counts.warning} warning, ` +
    `${counts.good} clean, ${counts.unknown} not enough data`;
  return (
    <span className="inline-flex items-center gap-1" title={tip}>
      {counts.critical > 0 && (
        <Badge tone="danger" title={tip}>
          ⚠ {counts.critical} line error{counts.critical === 1 ? "" : "s"}
        </Badge>
      )}
      {counts.warning > 0 && (
        <Badge tone="warning" title={tip}>
          {counts.warning} errors warn
        </Badge>
      )}
    </span>
  );
}
